var _defs, _rect, _rect2, _ellipse, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqureflap01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-139,.cls-138{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-139{stroke-width:3.14px;}.cls-138{stroke-dasharray:3;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 72.99,
    y: 213.46,
    width: 285.23,
    height: 109.98
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 75.99,
    y: 216.46,
    width: 279.23,
    height: 103.98
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.92,
    cy: 285.48,
    rx: 16.73,
    ry: 15.98
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.19,
    y: 263.77,
    width: 3.45,
    height: 44.47
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqureflap01);
export default __webpack_public_path__ + "static/media/SQURE FLAP-01.11f42ccbe1e06895076f208c5d6ac1bc.svg";
export { ForwardRef as ReactComponent };